import { Typography } from "@mui/material";

export const TitleDescription = ({ text }: { text: string }) => {
  if (!text) return null;
  return (
    <Typography
      sx={{
        color: "#024760",
        fontSize: "18px",
        fontWeight: 400,
        lineHeight: "22px",
      }}
    >
      {text}
    </Typography>
  );
};
